import React from 'react';
import Container from './Container';
import Text from './Text';
import Image from './Image';
import Date from './Date';

export default ({ token }) => (
  <Container>
    <Image src={token.image} />
    <Text>{token.title}</Text>
    <Date>{token.created_at}</Date>
  </Container>
);
